// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3l5gB","head":"Table_head__2Gjvo","col":"Table_col__nEN5T"};